export default {
	"d57acf7c1e4395c59b17cd68cc96e4b8": "支付金額"
}
